import useMountEffect from '@restart/hooks/useMountEffect';
import useUpdateEffect from '@restart/hooks/useUpdateEffect';
import React, { useRef } from 'react';
import { useSelector } from 'react-redux';

import Dock from './Dock';
import Robot from './Robot';

import OlMap from '@/helpers/OlMap';
import useMission from '@/hooks/useMissionForDJI';
import EventEmitter from '@/libs/EventEmitter';

const MapMapper = ({ data: robot }) => {
  const robotColor = useRef(robot.color);
  const droneOsd = useSelector((state) => state.telemetry[robot.id].droneOsd);
  const controlPayloads = useSelector((state) => state.telemetry[robot.id].controlPayloads);
  const dockOsdStatus = useSelector((state) => state.telemetry[robot.id].dockOsdStatus);

  useMission(robot);

  useMountEffect(() => {
    const subscribeToken = EventEmitter.subscribe(`${robot.id}/event/removeGoto`, () => {
      OlMap.removeGoto(robot.id);
    });

    return () => {
      EventEmitter.unsubscribe(subscribeToken);
      OlMap.removeHome(robot.id);
      OlMap.removeGoto(robot.id);
    };
  });

  useUpdateEffect(() => {
    const { latitude: lat, longitude: lng } = droneOsd;

    OlMap.addHomePath(robot.id, { lat, lng });
    OlMap.addGotoPath(robot.id, { lat, lng }, robotColor.current);
  }, [droneOsd]);

  useUpdateEffect(() => {
    let homePosition = null;
    if (controlPayloads) {
      homePosition = {
        lat: controlPayloads.home_latitude,
        lng: controlPayloads.home_longitude,
      };
    } else {
      homePosition = {
        lat: dockOsdStatus.latitude,
        lng: dockOsdStatus.longitude,
      };
    }

    OlMap.addHomeMarker(robot.id, homePosition, robotColor.current);
  }, [controlPayloads, dockOsdStatus]);

  useUpdateEffect(() => {
    robotColor.current = robot.color;
    OlMap.changeColor(robot.id, robotColor.current);
  }, [robot.color]);

  return (
    <>
      <Robot data={robot} />
      <Dock data={robot} />
    </>
  );
};

export default MapMapper;
